import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as chanceApi from '../../lib/api/chance';

//매입 발주서 리스트
const [
    LIST_PURCHASE_FILES,
    LIST_PURCHASE_FILES_SUCCESS,
    LIST_PURCHASE_FILES_FAILURE,
] = createRequestActionTypes('chance/LIST_PURCHASE_FILES');

export const listPurchaseFiles = createAction(
    LIST_PURCHASE_FILES,
    (fileTyp, fileAttrVal1, fileAttrVal2) => ({ fileTyp, fileAttrVal1, fileAttrVal2 }),
);

const listPurchaseFilesSaga = createRequestSaga(
    LIST_PURCHASE_FILES,
    chanceApi.getPurchseOrderFiles,
);

//매출 발주서 리스트
const [
    LIST_SALES_FILES,
    LIST_SALES_FILES_SUCCESS,
    LIST_SALES_FILES_FAILURE,
] = createRequestActionTypes('chance/LIST_SALES_FILES');

export const listSalesFiles = createAction(
    LIST_SALES_FILES,
    (fileTyp, fileAttrVal1, fileAttrVal2) => ({ fileTyp, fileAttrVal1, fileAttrVal2 }),
);
const listSalesFilesSaga = createRequestSaga(
    LIST_SALES_FILES,
    chanceApi.getPurchseOrderFiles,
);


export function* purchaseOrderFilesSaga() {
    yield takeLatest(LIST_PURCHASE_FILES, listPurchaseFilesSaga);
    yield takeLatest(LIST_SALES_FILES, listSalesFilesSaga);
}

const initialState = {
    purchaseFiles: null,
    salesFiles: null,
    error: null,
};

const purchaseOrderFiles = handleActions(
    {

        [LIST_PURCHASE_FILES_SUCCESS]: (state, { payload: data }) => ({
            ...state,
            purchaseFiles: data.list.map((file) => ({
                id: file.fileUuid,
                fileUrl: file.fileUrl,
                fileTyp: file.fileTyp,
                fileAttrVal1: file.fileAttrVal1, //prjUuid
                fileAttrVal2: file.fileAttrVal2,
                fileAttrVal3: file.fileAttrVal3,
                fileNm: file.fileNm,
                fileDesc: file.fileDesc,
                crtNm: file.crtNm,
                crtDt: file.crtDt,
                cngNm: file.cngNm,
                cngDt: file.cngDt,
            })),
            error: null,
        }),
        [LIST_PURCHASE_FILES_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error: error,
        }),
        [LIST_SALES_FILES_SUCCESS]: (state, { payload: data }) => ({
            ...state,
            salesFiles: data.list.map((file) => ({
                id: file.fileUuid,
                fileUrl: file.fileUrl,
                fileTyp: file.fileTyp,
                fileAttrVal1: file.fileAttrVal1, //prjUuid
                fileAttrVal2: file.fileAttrVal2,
                fileAttrVal3: file.fileAttrVal3,
                fileNm: file.fileNm,
                fileDesc: file.fileDesc,
                crtNm: file.crtNm,
                crtDt: file.crtDt,
                cngNm: file.cngNm,
                cngDt: file.cngDt,
            })),
            error: null,
        }),
        [LIST_SALES_FILES_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error: error,
        }),
    },
    initialState,
);

export default purchaseOrderFiles;


